import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmbassadorProgramCompanyUserService } from '../../../../services/ambassador-program-company-user.service';
import { timer, Subscription } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AmbassadorProgramCompanyUserDTO } from '../../../../models/ambassador-program-company-user-dto';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthJwtService } from '../../../../services/auth-jwt.service';

@Component({
  selector: 'ambassador-reservation-confirmation',
  standalone: true,
  templateUrl: './ambassador-reservation-confirmation.component.html',
  imports: [CommonModule]
})

export class AmbassadorReservationConfirmationComponent implements OnInit, OnDestroy {

  isLoading = true;
  isConfirmed = false;
  isCancelled = false;

  @Output() isConfirmedChange = new EventEmitter<boolean>();
  @Output() isCancelledChange = new EventEmitter<boolean>();
  @Output() confirmationStateChange = new EventEmitter<{ showConfirmed: boolean; showCancelled: boolean }>();

  private destroy$ = new Subject<void>();
  private pollingSubscription: Subscription;
  private userInfo: AmbassadorProgramCompanyUserDTO;

  constructor(
    private userService: AmbassadorProgramCompanyUserService,
    private router: Router,
    private authJwtService: AuthJwtService
  ) {
  }

  ngOnInit() {
    // Emitir estado inicial
    this.emitConfirmationState();
    this.startPolling();
    this.scrollToContent();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  scrollToContent() {
      // Esperar a que el DOM esté completamente renderizado
      setTimeout(() => {
          const programLogoElement = document.querySelector('.program-logo');
          const topbarElement = document.querySelector('.topbar');

          if (programLogoElement) {
              const topbarHeight = topbarElement ? topbarElement.getBoundingClientRect().height : 0;
              const programLogoPosition = programLogoElement.getBoundingClientRect().top + window.pageYOffset;
              const scrollPosition = programLogoPosition - topbarHeight;

              window.scrollTo({
                  top: scrollPosition,
                  behavior: 'smooth'
              });
          }
      }, 100);
  }

  private startPolling() {
    // Llamar inmediatamente (delay 0) y luego cada 5 segundos
    this.pollingSubscription = timer(0, 5000)
      .pipe(
        switchMap(() => this.userService.getProgramCompanyUserInfo()),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (userData) => {
          this.handleReservationStatus(userData?.IdReservationStatus);
          this.userInfo = userData;
        },
        (error) => {
          console.error('Error al verificar el estado de la reserva:', error);
        }
      );
  }

  private handleReservationStatus(status: number) {
    if (status === 1) {
      // Reserva confirmada
      this.isLoading = false;
      this.isConfirmed = true;
      this.isCancelled = false;
      this.emitConfirmationState();
      this.stopPolling();
    } else if (status === 0) {
      // Reserva cancelada
      this.isLoading = false;
      this.isConfirmed = false;
      this.isCancelled = true;
      this.emitConfirmationState();
      this.stopPolling();
    } else if (status === 3) {
      // Aún pendiente, seguir mostrando cargando
      this.isLoading = true;
      this.isConfirmed = false;
      this.isCancelled = false;
      this.emitConfirmationState();
    }
    this.scrollToContent();
  }

  private emitConfirmationState() {
    this.isConfirmedChange.emit(this.isConfirmed);
    this.isCancelledChange.emit(this.isCancelled);
    this.confirmationStateChange.emit({
      showConfirmed: this.isConfirmed,
      showCancelled: this.isCancelled
    });
  }

  private stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  confirmResetReservation(confirm: boolean) {

    if (confirm) {
      Swal.fire({
        title: 'Cancelar reserva',
        html: "¿Quieres cancelar esta reserva?<br> Ten en cuenta que esta acción no se puede deshacer.",
        icon: 'warning',
        buttonsStyling: false,
        customClass: {
          popup: 'custom-swal-popup',
          title: 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          cancelButton: 'custom-swal-cancel',
          confirmButton: 'custom-swal-confirm danger',
          icon: 'custom-swal-icon'
        },
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Cancelar reserva <i class="fa-solid fa-trash-can"></i>',
        cancelButtonText: 'Cerrar <i class="fa-solid fa-xmark"></i>',
        reverseButtons: false,
        focusCancel: true
      }).then((result) => {
        if (result.value) {
          this.resetReservation();
        }
      });
    }
    else {
      this.resetReservation();
    }
  }

  resetReservation() {
    this.userInfo.IdReservationSchedule = null;
    this.userInfo.IdReservationStatus = null;
    this.userInfo.TimePreference = null;
    this.userService.resetReservation().subscribe(res => {
      this.userService.setProgramCompanyUserData(this.userInfo);
      this.router.navigate(['/ambassador-home']);
    });
  }


  ambassadorlogout(): void {
    this.authJwtService.logout();
    window.localStorage.removeItem('idAmbassador');
    this.userService.clearProgramCompanyUserData();
    this.router.navigate(['/ambassador-login/' + this.userInfo.IdProgram]);
  }
}

